import {CustomerDesignStudioForm} from "./DesignStudioForm.js";

function initCustomerDesignStudioShowView() {
	new CustomerDesignStudioForm({
		formElement: document.querySelector('.design-studio-form')
	});
}

export {initCustomerDesignStudioShowView}
